
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.5 14h-.79l-.28-.27a6.518 6.518 0 10-.7.7l.27.28v.79l4.25 4.25a1.054 1.054 0 001.49-1.49L15.5 14zm-6 0a4.5 4.5 0 110-9 4.5 4.5 0 010 9z"}})])
          )
        }
      }
    